import { forwardRef } from "react";

import { Button } from "@/components/ui/button";

import { AdminJobCandidateDetails } from "@/queries/admin/job-details";
import { useAccelerateOptInReminderEmail } from "./mutation";

type BaseButtonProps = React.ComponentPropsWithoutRef<typeof Button>;

interface UpdateCandidateButtonProps extends BaseButtonProps {
  jobId: string;
  candidate: AdminJobCandidateDetails;
  onSuccess?: (data: AdminJobCandidateDetails) => void;
}

export const AccelerateCandidateOptInEmailButton = forwardRef<
  HTMLButtonElement,
  UpdateCandidateButtonProps
>(({ jobId, candidate, onSuccess, ...buttonProps }, ref) => {
  const { accelerateOptInReminderEmail, isAccelerateOptInReminderEmail } =
    useAccelerateOptInReminderEmail({
      openingId: jobId,
      candidateStatusId: candidate.candidateStatusId,
      optInReminderId: candidate.nextOptInRequestId ?? "",
      onSuccessCb: (data: AdminJobCandidateDetails) => {
        onSuccess?.(data);
      },
    });

  const handleClick = () => {
    accelerateOptInReminderEmail();
  };

  if (
    candidate.opportunityStatus !== "Checking Interest" ||
    !candidate.nextOptInRequestId
  ) {
    return;
  }

  return (
    <>
      <Button
        {...buttonProps}
        ref={ref}
        variant="stroke"
        disabled={isAccelerateOptInReminderEmail}
        onClick={handleClick}
      >
        Sent Opt-In Reminder Now
      </Button>
    </>
  );
});
AccelerateCandidateOptInEmailButton.displayName =
  "AccelerateCandidateOptInEmailButton";
